import React, { useEffect, useState, useRef } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import '../wonders.css';
import scrolldown from '../img/Arrow Down.png';
import insider1 from '../img/Wonders/Accom 1.png';
import arrow1 from '../img/Vector 2.png';
import insider2 from '../img/Wonders/Twizel Salmon Farm 1 1.png';
import arrow2 from '../img/Vector 1.png';
import insider3 from '../img/Wonders/LH6zF0bI 1.png';
import arrow3 from '../img/Vector 6.png';
import arrow4 from '../img/Vector 3.png';
import insider4 from '../img/Wonders/Group 12.png';
import bannerImg from '../img/Wonders/Whales Tale - Mountain 3 of 3 3.jpeg';
import bannerImgMobile from '../img/Wonders/Whales Tale - Mountain 3.jpeg';
import activityBanner1 from '../img/Wonders/Whale Watching Wawahia _ Tail photo Whale Watch Kaikoura 1.jpg';
import activityImg1 from '../img/Wonders/Tui at ZEALANDIA Photo Credit - Brendan Doran 1.jpg';
import activityImg2 from '../img/Wonders/TranzAlpine--Lake-Sarah-in-Snow--AG 1.jpg';
import activityImg3 from '../img/Wonders/Milford Sounds 1.jpg';
import activityImg4 from '../img/Wonders/Aurora_Australis 1.jpg';
import foodImg1 from '../img/Wonders/thumbnail_IMG_6982 1.jpg';
import foodImg2 from '../img/Wonders/rita_aro-st_plates__FocusFillWyItMC4wOCIsIi0wLjE5IiwxMjAwLDYwMF0 1.jpg';
import foodImg3 from '../img/Wonders/Milford Lodge Menu_By Johnny Hendrikus_2022-5 1.jpg';
import foodImg4 from '../img/Wonders/Wine With Lunch 1.jpg';
import bannerImg2 from '../img/Wonders/Hapuku-Lodge-Treehouses-in-Kaikoura 1.jpeg';
import LodgingCarousel from '../components/wonders-lodging-carousel';
import mountain from '../img/image 1.png';
import booknow from '../img/Book Now Button.png';
import arrowRight from '../img/Arrow Right - transparent.png';
import arrowLeft from '../img/Arrow Left - transparent.png';

import foodImg1Mobile from '../img/Wonders/thumbnail_IMG_6993 1.jpg';
import foodImg2Mobile from '../img/Wonders/rita_aro-st_plates__FocusFillWyItMC4wOCIsIi0wLjE5IiwxMjAwLDYwMF0 1 copy.jpg';
import foodImg4Mobile from '../img/Wonders/Milford Lodge Menu_By Johnny Hendrikus_2022-5 1 copy.jpg';
import foodImg3Mobile from '../img/Wonders/Wine With Lunch 1 copy.jpg';
import insider1Mobile from '../img/Wonders/Accom 2.jpg';
import insider2Mobile from '../img/Wonders/Twizel Salmon Farm 1 2.jpg';
import insider3Mobile from '../img/Wonders/LH6zF0bI 2.jpg';
import insider4Mobile from '../img/Wonders/Group 21.png';
import familyIcon from '../img/Family Friendly Icon.png';
import { useLocation } from 'react-router-dom';

const Wonders = ({ winterEscapeRef }) => {
    const location = useLocation()
    useEffect(() => {
        if (location.hash === "#review") {
            setTimeout(() => {
                ref4.current.scrollIntoView({ behavior: "smooth" });
            }, 500)
        }
    }, [location]);

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);

    useEffect(() => {
        console.log(document.getElementById("review"));
    }, []);

    const handleClick = (ref) => (event) => {
        event.preventDefault();
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <>
            <div id="top" className="subPage-banner" ref={ref5}>
                <div className="banner-img desktop"><img src={bannerImg} alt="banner-img" /></div>
                <div className="banner-img mobile"><img src={bannerImgMobile} alt="banner-img-mobile" /></div>
                <div className="banner-header">
                    <h1 className="desktop" data-aos="zoom-out">Wonders in<br />the Wild</h1>
                    <h1 className="mobile" data-aos="zoom-out">Wonders<br />in the Wild</h1>
                </div>
                <div className="btm-text">
                    <div className="name white">Whale Watching, Kaikoura</div>
                </div>
            </div>
            <div className="subMenu pt-4 pt-sm-0">
                <ul className="d-flex align-items-center justify-content-between">
                    <li><a href="#activities" onClick={handleClick(ref1)}>Activities</a></li>
                    <li><a href="#dining" onClick={handleClick(ref2)}>Dining</a></li>
                    <li><a href="#lodging" onClick={handleClick(ref3)}>Lodging</a></li>
                    <li><a href="#review" onClick={handleClick(ref4)}>Nellie Lim's Review</a></li>
                </ul>
            </div>
            <div className="peakThrills-activities container section">
                <div className="anchor" id="activities" ref={ref1}></div>
                <div className="content" data-aos="fade-up">
                    <h2 className="violet">Activities</h2>
                    <h3 className="pt-sm-3 desktop">Head over to our winter wonderland and <br />catch nature's natural wonders in action.</h3>
                    <h3 className="mobile">Head over to our winter <br />wonderland and catch nature's <br />natural wonders in action.</h3>
                    <p className="pt-sm-5 pt-4">Our Air New Zealand crew aren't the only ones waiting to greet you. From resident whales, penguins and nocturnal wildlife, to towering cliffs and waterfalls, a warm welcome awaits you this winter.</p>
                </div>
            </div>
            <div data-aos="fade-up">
                <div className="activity-body wonders-activities">
                    <div className="row">
                        <div className="col-sm-6 left-col p-left activity-body-col-1">
                            <div className="thumbnail-img pt-5">
                                <img className="full-width" src={activityImg1} alt="activity-img-1" />
                                <div className="copyright white">© Brendan Doran</div>
                            </div>
                            <div className="content pb-5 ps-5 px-5 px-sm-0">
                                <div className="d-flex align-items-center">
                                    <h3>Zealandia, <span className="violet">Wellington</span></h3>
                                    <div className="family-tooltip ms-4">
                                        <img className="family-icon" src={familyIcon} alt="family-icon" />
                                        <span className="tooltip-hover-text">
                                            Family-friendly
                                        </span>
                                    </div>
                                </div>
                                <p>Explore this sanctuary during winter to witness rare species of birds flocking together and be immersed in nature's nightlife, such as the rare little spotted kiwi, earlier in the evening.</p>
                                <p className="small-text light-italic location">53 Waiapu Road, Karori, Wellington 6012, <br /> New Zealand</p>
                            </div>
                            <div className="mobile">
                                <div className="d-flex flex-wrap align-items-center flex-row-reverse">
                                    <div className="thumbnail-img pt-5 w-sm-5 ps-5 ps-sm-0">
                                        <img className="full-width" src={activityImg3} alt="activity-img-2" />
                                    </div>
                                    <div className="content ps-5 ps-sm-0 w-sm-5 pt-5">
                                        <div className="d-flex align-items-center">
                                            <h3>Milford Sound Cruise</h3>
                                            <div className="family-tooltip ms-4">
                                                <img className="family-icon" src={familyIcon} alt="family-icon" />
                                                <span className="tooltip-hover-text">
                                                    Family-friendly
                                                </span>
                                            </div>
                                        </div>
                                        <p>Hop on a scenic cruise along one of New Zealand's most spectacular fjords with sky-scraping mountains and one of the tallest waterfalls in the world.</p>
                                        <p className="small-text light-italic location">1 Milford Sound Highway, Milford Sound 9679, New Zealand</p>
                                    </div>
                                </div>
                            </div>
                            <div className="thumbnail-img pt-5 pe-0 mt-5 mt-sm-0">
                                <img className="full-width" src={activityImg2} alt="activity-img-1" />
                                <div className="copyright">© Great Journeys New Zealand</div>
                            </div>
                            <div className="content pt-3 pb-5 px-5 px-sm-0">
                                <h3>TranzAlpine Train, <span className="violet">Southern Alps</span></h3>
                                <p>Whisk through gorgeous mountain ranges, forests and lakes dusted with snow, and enjoy short breaks to hop off, stretch your legs and take in these stunning sights.</p>
                                <p className="small-text light-italic location">Troup Drive, Addington, Christchurch 8011, <br />New Zealand</p>
                            </div>
                        </div>
                        <div className="col-sm-6 right-col p-left-half activity-body-col-2">
                            <div className="desktop">
                                <div className="thumbnail-img pt-5 w-sm-5 ps-5 ps-sm-0">
                                    <img className="full-width" src={activityImg3} alt="activity-img-2" />
                                </div>
                                <div className="content ps-5 ps-sm-0 w-sm-5 pt-3">
                                    <div className="d-flex align-items-center">
                                        <h3>Milford Sound Cruise</h3>
                                        <div className="family-tooltip ms-4">
                                            <img className="family-icon" src={familyIcon} alt="family-icon" />
                                            <span className="tooltip-hover-text">
                                                Family-friendly
                                            </span>
                                        </div>
                                    </div>
                                    <p>Hop on a scenic cruise along one of New Zealand's most spectacular fjords with sky-scraping mountains and one of the tallest waterfalls in the world.</p>
                                    <p className="small-text light-italic location">1 Milford Sound Highway, Milford Sound 9679, <br />New Zealand</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="activity-body wonders-activities second pb-5">
                    <div className="row align-items-end">
                        <div className="col-sm-7 left-col pe-0 pe-sm-5 ps-0">
                            <div className="thumbnail-img pt-5">
                                <img className="full-width" src={activityImg4} alt="activity-img-3" />
                            </div>
                        </div>
                        <div className="col-sm-5 right-col ps-5">
                            <div className="content pb-5 desktop">
                                <div className="tip-box movie" data-aos="zoom-out">
                                    <p>
                                        <span className="weight-medium">Air New Zealand Travel Tip:</span><br />
                                        Check out hours of kid-friendly movies, shows and games to keep your little ones entertained, with parental lock and screen sharing features too.
                                    </p>
                                    <button><a href="https://www.airnewzealand.com.sg/special-assistance-flying-with-children-infants#entertainment" target="_blank">Learn More</a></button>
                                </div>
                            </div>
                            <div className="content pt-0 pt-sm-3">
                                <h3>Southern Lights, <span className="violet">Stewart Island</span></h3>
                                <p>Treat your senses to the glowing skies at the world's southernmost Dark Sky Sanctuary, where you can catch a glimpse of the Southern Lights during clear winter nights.</p>
                                <p className="small-text light-italic location">Stewart Island, New Zealand</p>
                            </div>
                            <div className="content pt-5 mobile" data-aos="zoom-out">
                                <div className="tip-box movie">
                                    <p>
                                        <span className="weight-medium">Air New Zealand Travel Tip:</span><br />
                                        Check out hours of kid-friendly movies, shows and games to keep your little ones entertained, with parental lock and screen sharing features too.
                                    </p>
                                    <button><a href="https://www.airnewzealand.com.sg/special-assistance-flying-with-children-infants#entertainment" target="_blank">Learn More</a></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="thumbnail-banner activities-thumbnail-banner pt-5 my-sm-5">
                    <img className="full-width" src={activityBanner1} alt="activity-banner-1" />
                </div>
                <div className="activity-body p-right px-5 px-sm-0">
                    <div className="content m-right-0">
                        <div className="d-flex align-items-center">
                            <h3>Whale Watching, <span className="violet">Kaikoura</span></h3>
                            <div className="family-tooltip ms-4">
                                <img className="family-icon" src={familyIcon} alt="family-icon" />
                                <span className="tooltip-hover-text">
                                    Family-friendly
                                </span>
                            </div>
                        </div>
                        <p>Bring your little ones to meet our resident giant sperm whales, plus catch a glimpse of humpback whales and other majestic creatures during peak migration season between June and July.</p>
                        <p className="small-text light-italic location">Whaleway Station Road, Kaikōura 7340, <br />New Zealand</p>
                    </div>
                </div>
            </div>
            <div className="scroll-down text-center pt-5 mt-5 z-index-1" data-aos="zoom-out">
                <p className="violet"><span className="serif-bold">Next up,</span> Dining</p>
                <a href="#food" onClick={handleClick(ref2)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
            </div>
            <div className="section food purple-bg wonders position-relative">
                <div className="anchor" id="dining" ref={ref2}></div>
                <div className="row desktop py-5 mb-5 " data-aos="fade-up">
                    <div className="col-sm-6 left-col pt-5">
                        <div className="pe-sm-0 p-left-2x">
                            <div className="thumbnail-img w-sm-5">
                                <img className="full-width" src={foodImg1} alt="activity-img-1" />
                                <div className="copyright white">© Karaka Lobster</div>
                            </div>

                            <div className="content pb-5 w-sm-8">
                                <h3 className="pt-sm-3">Karaka Lobster, <span className="violet">Kaikoura</span></h3>
                                <p>Giant lobsters and crayfish to fuel you up on your journey</p>
                                <p className="small-text light-italic location">Okiwi Bay, 2825 State Highway 1, Kaikōura, <br />New Zealand</p>
                            </div>
                        </div>
                        <div className="thumbnail-img pt-5 mt-5 w-sm-5 pe-5">
                            <img className="full-width" src={foodImg2} alt="activity-img-1" />
                            <div className="copyright white">© Wellington NZ</div>
                        </div>
                        <div className="content pt-3 pb-5 w-sm-5 p-left-2x pe-5">
                            <h3>Rita,  <span className="violet">Wellington</span></h3>
                            <p>Seasonal flavours with a menu to match every season</p>
                            <p className="small-text light-italic location">89 Aro Street, Aro Valley, Wellington 6021, <br />New Zealand</p>
                        </div>
                    </div>
                    <div className="col-sm-6 right-col">
                        <div>
                            <div className="content p-right food-header">
                                <h2 className="violet">Dining</h2>
                                <h3 className="pt-sm-3 desktop p-left">Warm yourself up with delicious winter delights, freshly sourced near you.</h3>
                                <p className="pt-sm-4">Nature on a plate, coming right up. Explore unique New Zealand dishes made with fresh, seasonal produce.</p>
                                <p>Unearth a wide variety of root vegetables with their comforting flavours; a staple of winter cooking.</p>

                            </div>
                            <div className="p-left-half">
                                <div className="thumbnail-img w-sm-5">
                                    <img className="full-width" src={foodImg3} alt="activity-img-2" />
                                    <div className="copyright white">© Milford Sound Lodge</div>
                                </div>
                                <div className="content pt-3 w-sm-5 p-right-2x pb-5">
                                    <h3>Pio Pio Café & Restaurant, <span className="violet">Milford Sound</span></h3>
                                    <p>Sample fresh fiordland finds including wild venison and blue cod</p>
                                    <p className="small-text light-italic location">State Highway 94 Milford Sound, 9679, <br />New Zealand</p>
                                </div>
                            </div>
                        </div>
                        <div className="p-left p-right-2x mt-5 ms-5 pt-5">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg4} alt="activity-img-2" />
                                <div className="copyright white">© Great Journeys New Zealand</div>
                            </div>
                            <div className="content pt-3 w-sm-5">
                                <h3>Scenic Cafe, <span className="violet">TranzAlpine Train</span></h3>
                                <p>Comforting meals to complement the stunning views</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="food-body mobile pb-5" data-aos="fade-up">
                    <div className="food-header text-center pb-5 px-5 px-sm-0" data-aos="fade-up">
                        <h2 className="violet">Dining</h2>
                        <h3 className="pt-4">Warm yourself up with delicious winter delights, freshly sourced near you.</h3>
                        <p className="pt-4">Nature on a plate, coming right up. Explore unique New Zealand dishes made with fresh, seasonal produce.</p>
                        <p className="pt-4">Unearth a wide variety of root vegetables with their comforting flavours; a staple of winter cooking.</p>
                    </div>
                    <div className="row row-1 py-5 d-flex align-items-center">
                        <div className="col-6 pe-5 ps-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg1Mobile} alt="food-img-1" />
                                <div className="copyright white">© Karaka Lobster</div>
                            </div>
                        </div>
                        <div className="col-6 pe-5">
                            <div className="content">
                                <h3>Karaka Lobster, <span className="violet">Kaikoura</span></h3>
                                <p>Giant lobsters and crayfish to fuel you up on your journey</p>
                                <p className="small-text light-italic location">Okiwi Bay, 2825 State Highway 1, <br />Kaikōura, New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-2 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg2Mobile} alt="food-img-2" />
                                <div className="copyright white">© Wellington NZ</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>Rita, <span className="violet">Wellington</span></h3>
                                <p>Seasonal flavours with a menu to match every season</p>
                                <p className="small-text light-italic location">89 Aro Street, Aro Valley, <br />Wellington 6021, New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-3 d-flex align-items-center py-5">
                        <div className="col-6 ps-5">
                            <div className="content">
                                <h3>Pio Pio Café & Restaurant,  <br /><span className="violet">Milford Sound</span></h3>
                                <p>Sample fresh fiordland finds including wild venison and blue cod</p>
                                <p className="small-text light-italic location">State Highway 94 Milford Sound, <br />9679, New Zealand 3951</p>
                            </div>
                        </div>
                        <div className="col-6 ps-5 pe-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg4Mobile} alt="food-img-3" />
                                <div className="copyright">© Milford Sound Lodge</div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-4 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg3Mobile} alt="food-img-4" />
                                <div className="copyright white">© Great Journeys New Zealand</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>Scenic Cafe, <span className="violet">TranzAlpine Train</span></h3>
                                <p>Comforting meals to complement the stunning views</p>
                            </div>
                        </div>
                    </div>
                    <div className="scroll-down absolute text-center pt-4 full-width" data-aos="zoom-out">
                        <p className="violet"><span className="serif-bold">Next up,</span> Lodging</p>
                        <a href="#lodging" onClick={handleClick(ref3)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                    </div>
                </div>

                <div className="scroll-down absolute text-center pt-4 full-width desktop" data-aos="zoom-out">
                    <p className="violet"><span className="serif-bold">Next up,</span> Lodging</p>
                    <a href="#lodging" onClick={handleClick(ref3)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                </div>
            </div>
            <div className="section lodging" data-aos="fade-up">
                <div className="anchor" id="lodging" ref={ref3}></div>
                <div className="row">
                    <div className="col-sm-4 col-sm-12 p-left pt-5">
                        <h2 className="violet">Lodging</h2>
                        <div className="header lodging">
                            <h3 className="pt-3 desktop">Be nestled in the beauty <br />of nature.</h3>
                            <h3 className="pt-3 mobile">Be nestled in the beauty of nature.</h3>
                            <p className="pt-3">Spend a night in tranquillity while still enjoying the warmth and comfort of modern day living. New Zealand has everything you need to make winter your wonderland.</p>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-12 p-left">
                        <LodgingCarousel />
                    </div>
                </div>
            </div>
            <div className="banner thumbnail-banner pt-5 desktop">
                <img className="full-width" src={bannerImg2} alt="banner-img-2" />
                <div className="name white">Hapuku Lodge + Tree Houses</div>
                <div className="scroll-down text-center pt-5 mt-5 absolute" data-aos="zoom-out">
                    <p className="white"><span className="serif-bold">Next up,</span> Insider's Trip Review</p>
                    <a href="#review" onClick={handleClick(ref4)} class="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                </div>
            </div>
            <div className="banner thumbnail-banner pt-5 mt-5 mobile">
                <div className="scroll-down text-center pt-5 mt-5 absolute" data-aos="zoom-out">
                    <p className="violet"><span className="serif-bold">Next up,</span> Insider's Trip Review</p>
                    <a href="#review" onClick={handleClick(ref4)} class="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                </div>
            </div>
            <div id="review" ref={ref4}>
                <div className="section subPage-reviews desktop purple-bg">
                    {/* <div className="anchor" id="review" ref={ref4}></div> */}
                    <div data-aos="fade-up">
                        <h2 className="text-center violet py-5">Insider's Trip Review:</h2>
                        <div className="row pt-5">
                            <div className="col-sm-6 p-right-half">
                                <div className="content m-right-0">
                                    <h3>Nellie Lim (@nellielim)</h3>
                                    <p>Stunning natural sceneries from a different perspective – up high in the skies (just like the views from the Air New Zealand cabin). See what Nellie got up to on her recent trip to discover New Zealand's wintry outdoors.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 p-left-half">
                                <div className="tip-box insider wonders">
                                    <p>
                                        <span className="weight-medium">Nellie's Trip Tip: </span><br />
                                        Buffer an extra day or two for activities that are weather-dependent, such as helicopter rides or heading up to the mountain tops.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row section px-sm-4">
                            <div className="col-sm-7 left-col pe-5 p-left-2x insider-overlap-top-section-wrap wonders">
                                <div className="insider-overlap-top-section wonder text-right">
                                    <div className="content absolute">
                                        <h4 className="text-left" data-aos="fade-in">“I was blown away by stunning view of Aoraki/Mount Cook and breathtaking glaciers.”</h4>
                                    </div>
                                    <div className="thumbnail-img pe-5">
                                        <img className="full-width" alt="activity-img=3" src={insider4} />
                                        <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow3} alt="arrow-1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-5 right-col">
                                <div className="content insider-overlap-top-section-content">
                                    <h3 className="number violet">1</h3>
                                    <h3>Helicopter ride up to Brass Peak, <span className="violet">Aoraki/Mount Cook </span></h3>
                                    <p className="pt-3">We chartered a scenic private helicopter ride with Mount Cook Ski Planes & Helicopters and it was the most magical experience of our entire trip.</p>
                                    <p className="pt-3">It was truly a sight to behold once we landed on Brass Peak and we marvelled at the magnificent landscape of New Zealand.</p>
                                </div>
                            </div>
                        </div>
                        <div className="insider-overlap-section wonders">
                            <div className="z-index-3 overlapping-row d-flex flex-wrap">
                                <div className="w-4"></div>
                                <div className="w-6">
                                    <div className="top d-flex">
                                        <div className="images w-6">
                                            <img className="thumbnail-img" src={insider1} alt="insider-1" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow1} alt="arrow-1" />
                                            <img className="thumbnail-arrow mobile" src={arrow4} alt="arrow-4" />
                                            <div className="content mobile">
                                                <h3 className="number violet">2</h3>
                                                <h3>Blue Pools, <span className="violet">Makarora</span> </h3>
                                                <p className="pt-3">Enjoy winter activities off the mountain, like a road trip to Makarora for the Blue Pools.</p>
                                            </div>
                                        </div>
                                        <div className="content w-4 pb-5 ps-5">
                                            <h4 data-aos="fade-in">“The best way to experience true nature with everything you need.”</h4>
                                        </div>
                                    </div>
                                    <div className="bottom">
                                        <div className="content">
                                            <h3 className="number violet">2</h3>
                                            <h3>Britz Campervans, <span className="violet">Christchurch</span> </h3>
                                            <p className="pt-3">We've always stayed in luxurious 6-berth campervans every time we're in New Zealand.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="z-index-1 overlapping-row">
                                <div className="top d-flex align-items-end">
                                    <div className="content w-4 pe-5">
                                        <h4 data-aos="fade-in">“Fresh sashimi, sushi and even smoked salmon bagels await you.”</h4>
                                    </div>
                                    <div className="images w-6">
                                        <div className="thumbnail-img-container">
                                            <img className="thumbnail-img" src={insider2} alt="insider-2" />
                                        </div>
                                        <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow2} alt="arrow-2" />
                                        <img className="thumbnail-arrow mobile" src={arrow4} alt="arrow-4" />
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="content w-4">
                                        <h3 className="number violet">3</h3>
                                        <h3>Twizel Salmon Farm, <span className="violet">Glenbrook</span> </h3>
                                        <p className="pt-3">I'm a huge fan of salmon so I always make it a point to get brunch here. You can even try your hand at fishing for some salmon!</p>
                                    </div>
                                </div>
                            </div>
                            <div className="z-index-2 overlapping-row d-flex">
                                <div className="w-45"></div>
                                <div className="w-55">
                                    <div className="top d-flex align-items-end">
                                        <div className="images col-sm-12">
                                            <img className="thumbnail-img" src={insider3} alt="insider-3" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow3} alt="arrow-3" />
                                            <img className="thumbnail-arrow mobile" src={arrow1} alt="arrow-1" />
                                        </div>
                                    </div>
                                    <div className="bottom d-flex align-items-center">
                                        <div className="content w-5">
                                            <h3 className="number violet">4</h3>
                                            <h3>Shamarra Alpaca Farm, <span className="violet">Akaroa</span> </h3>
                                            <p className="pt-3">This is one of the only farms where you get to cuddle and bond with their alpacas.</p>
                                        </div>
                                        <div className="content w-5 ps-5">
                                            <h4 data-aos="fade-in">“An interactive tour around the ultimate land of cute!”</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section subPage-reviews mobile purple-bg">
                    {/* <div className="anchor" id="review" ref={ref4}></div> */}
                    <div data-aos="fade-up">
                        <h2 className="text-center violet pt-5">Insider's Trip Review:</h2>
                        <div className="row pt-0 px-5 text-center">
                            <div className="col-sm-6">
                                <div className="content m-right-0">
                                    <h3>Nellie Lim (@nellielim)</h3>
                                    <p>Stunning natural sceneries from a different perspective – up high in the skies (just like the views from the Air New Zealand cabin). See what Nellie got up to on her recent trip to discover New Zealand's wintry outdoors.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 pt-5">
                                <div className="tip-box insider wonders">
                                    <p>
                                        <span className="weight-medium">Nellie's Trip Tip: </span><br />
                                        Buffer an extra day or two for activities that are weather-dependent, such as helicopter rides or heading up to the mountain tops.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row section">
                            <div className="col-12 px-0 insider-top-section-img-mobile wonders">
                                <div className="thumbnail-img pt-5">
                                    <img className="full-width" alt="activity-img=3" src={insider4Mobile} />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="col-12 px-5 insider-top-section-content-mobile wonders">
                                <div className="content pt-3 w-sm-5">
                                    <h4>“I was blown away by stunning view of Aoraki/Mount Cook and breathtaking glaciers.”</h4>
                                </div>
                                <div className="content pt-3">
                                    <h3 className="number violet">1</h3>
                                    <h3>Helicopter ride up to Brass Peak, <span className="violet">Aoraki/Mount Cook </span></h3>
                                    <p className="pt-3">We chartered a scenic private helicopter ride with Mount Cook Ski Planes & Helicopters and it was the most magical experience of our entire trip.</p>
                                    <p className="pt-3">It was truly a sight to behold once we landed on Brass Peak and we marvelled at the magnificent landscape of New Zealand.</p>
                                </div>
                            </div>
                        </div>
                        <div className="insider-sub-section wonders">
                            <div className="row row-1">
                                <div className="col-12 px-0 relative">
                                    <img className="thumbnail-img full-width" src={insider1Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="row align-items-center row-1-content">
                                <div className="col-6 ps-5 pe-2">
                                    <div className="content">
                                        <h3 className="number violet">2</h3>
                                        <h3>Britz Campervans, <span className="violet">Christchurch</span> </h3>
                                        <p className="">We've always stayed in luxurious 6-berth campervans every time we're in New Zealand.</p>
                                    </div>
                                </div>
                                <div className="col-6 ps-5 pe-5">
                                    <div className="content right">
                                        <h4>“The best way to experience true nature with everything you need.”</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-2 pt-5 align-items-end pb-5 ">
                                <div className="col-6 ps-5 pe-2">
                                    <div className="content top">
                                        <h4>“Fresh sashimi, sushi and even smoked salmon bagels await you.”</h4>
                                    </div>
                                    <div className="content w-4">
                                        <h3 className="number violet">3</h3>
                                        <h3>Twizel Salmon Farm, <span className="violet">Glenbrook</span> </h3>
                                        <p className="">I'm a huge fan of salmon so I always make it a point to get brunch here. You can even try your hand at fishing for some salmon!</p>
                                    </div>
                                </div>
                                <div className="col-6 ps-2 pe-0 relative">
                                    <img className="thumbnail-img full-width" src={insider2Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow4} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="row row-3 align-items-center pt-5">
                                <div className="col-12 px-0 relative">
                                    <img className="thumbnail-img full-width" src={insider3Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                                <div className="col-6 ps-5 pe-5">
                                    <div className="content left">
                                        <h4>“An interactive tour around <br />the ultimate <br />land of cute!”</h4>
                                    </div>
                                </div>
                                <div className="col-6 ps-3 pe-5">
                                    <div className="content w-4">
                                        <h3 className="number violet">4</h3>
                                        <h3>Shamarra Alpaca Farm, <span className="violet">Akaroa</span> </h3>
                                        <p className="">This is one of the only farms where you get to cuddle and bond with their alpacas.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mountainImg purple-bg">
                <img className="full-width" src={mountain} alt="mountain" />
            </div>
            <div className="footer-CTA text-center" data-aos="fade-up">
                <h2 className="pb-4">Ready for your winter escape?</h2>
                <a ref={winterEscapeRef} href="https://flightbookings.airnewzealand.com.sg/vbook/actions/ext-search" target="_blank"><img className="bookNow-btn" src={booknow} alt="booknow" /></a>
            </div>
            <div className="newsletter purple-bg section text-center">
                <p className="violet weight-medium">Get the latest flight deals and travel tips</p>
                <h2 className="pb-4">Join our newsletter</h2>
                <button><a href="https://www.airnewzealand.com.sg/email-offer-signup" target="_blank">Sign Up</a></button>
            </div>
            <div className="services-page purple-bg">
                <div className="row d-flex flex-wrap">
                    <div className="col-6 services-pagination-col peak d-flex flex-wrap align-items-center justify-content-start">
                        <NavHashLink to='/peak-thrills'><img className="prevArrow me-3" src={arrowLeft} alt="arrow-left" /></NavHashLink>
                        <NavHashLink to='/peak-thrills'><h2>Peak Thrills</h2></NavHashLink>
                    </div>
                    <div className="col-6 services-pagination-col chillOut d-flex flex-wrap align-items-center justify-content-end">
                        <NavHashLink to='/chill-out-and-about'><h2>Chill Out and About</h2></NavHashLink>
                        <NavHashLink to='/chill-out-and-about'><img className="nextArrow ms-3" src={arrowRight} alt="arrow-right" /></NavHashLink>
                    </div>
                    <div className="scroll-down text-center absolute">
                        <p>Back to the top</p>
                        <a href="#top"><img src={scrolldown} alt="scroll-down" /></a>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Wonders;
